import * as React from 'react';

export function getInteractionSeverity(type, value) {
  if (typeof type === 'string') {
    switch (type) {
      case 'icon':
        return getInteractionSeverityIcon(value);
      case 'statusLabel':
        return getInteractionSeverityStatusLabel(value);
      case 'iconLabel':
        return getInteractionSeverityIconLabel(value);
    }
  } else {
    return value;
  }
}

function getInteractionSeverityIcon(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <span className="pi pi-times-circle" style={{ color: '#d32f2f', paddingRight: "10px" }}></span>;
      case 2:
        return <span className="pi pi-exclamation-triangle" style={{ color: '#f57c00', paddingRight: "10px" }}></span>;
      case 3:
        return <span className="pi pi-exclamation-triangle" style={{ color: '#fbc02d', paddingRight: "10px" }}></span>;
      case 4:
        return <span className="pi pi-circle-on" style={{ color: '#b3b3b3', paddingRight: "10px" }}></span>;
      default:
        return null;
    }
  }
  return null;
}

function getInteractionSeverityIconLabel(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <><span className="pi pi-times-circle" style={{ color: '#d32f2f' }}></span> Major</>;
      case 2:
        return <><span className="pi pi-exclamation-triangle" style={{ color: '#f57c00' }}></span> Moderate</>;
      case 3:
        return <><span className="pi pi-exclamation-triangle" style={{ color: '#fbc02d' }}></span> Minor</>;
      case 4:
        return <><span className="pi pi-circle-on" style={{ color: '#b3b3b3' }}></span> Unknown</>;
      default:
        return null;
    }
  }
  return null;
}

function getInteractionSeverityStatusLabel(id: number) {
  if (id != undefined) {
    switch (id) {
      case 1:
        return <span style={{
          marginTop: ".5rem", marginRight: ".75rem", display: "inline", padding: "0.5em",
          border: "2px solid black", borderRadius: "24px", borderColor: "#d32f2f", color: '#b71c1c', fontSize: 15
        }}>Major</span>;
      case 2:
        return <span style={{
          marginTop: ".5rem", marginRight: ".75rem", display: "inline", padding: "0.5em",
          border: "2px solid black", borderRadius: "24px", borderColor: "#f57c00", color: '#d04900', fontSize: 15
        }}>Modarate</span>;
      case 3:
        return <span style={{
          marginTop: ".5rem", marginRight: ".75rem", display: "inline", padding: "0.5em",
          border: "2px solid black", borderRadius: "24px", borderColor: "#fbc02d", color: '#8a6600', fontSize: 15
        }}>Minor</span>;
      case 4:
        return <span style={{
          marginTop: ".5rem", marginRight: ".75rem", display: "inline", padding: "0.5em",
          border: "2px solid black", borderRadius: "24px", borderColor: "#b3b3b3", color: "#606060", fontSize: 15
        }}>Unknown</span>;
      default:
        return null;
    }
  }
  return null;
}

export default getInteractionSeverity;

